import React from 'react';
import AppConfig from "../../services/AppConfig";

interface Props {
    icon: JSX.Element;
    size?: 'large' | "medium" | "small";
    className?: string;
    color?: "warning" | "primary" | "success" | "danger";
    forceEllipseInDarkMode?: true;
}

const RoundedIcon = ({icon, size, className, color, forceEllipseInDarkMode}: Props) => {
    const showEllipse = () => {
        if (!AppConfig.isDarkMode()) return true;

        return forceEllipseInDarkMode;
    }

    return (
        <div className={`rounded-icon ${color ? `text-${color}` : ""} ${size ? size : "large"} ${className ?? ""}`}>
            <div className={`ellipse ${!showEllipse() ? "ellipse-transparent" : ""}`}/>
            {icon}
        </div>
    )
}

export default RoundedIcon;